// extracted by mini-css-extract-plugin
export default {"FetchError":"SelectInput_FetchError__C4tpb"};